import React, { useMemo } from 'react';
import { Card, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TooltipInfoIcon } from '@icons';

const RadarCard = ({
  cardId,
  radarRowId,
  containerRef, // ✅ ref opzionale per misurare la width
  Icon,
  iconClassName,
  titleCode,
  tooltipPlacement,
  translations,
  data,
  compareData,
  radarDivWidth,
  radarColor,
  maxValue,
  renderRadar,
}) => {
  const titleText = useMemo(
    () => translations.filter((t) => t.code === titleCode).map((t) => t.text),
    [translations, titleCode],
  );

  const titleDesc = useMemo(
    () => translations.filter((t) => t.code === titleCode).map((t) => t.description),
    [translations, titleCode],
  );

  return (
    <Card className='cards-utente d-none d-lg-block pb-0 mt-0' id={cardId}>
      <Card.Body>
        {Icon ? <Icon className={iconClassName} /> : null}

        <Card.Title className='text-uppercase pt-3'>
          {titleText}
          <OverlayTrigger
            placement={tooltipPlacement ?? 'right'}
            delay={{ show: 200, hide: 400 }}
            overlay={<Tooltip id='button-tooltip'>{titleDesc}</Tooltip>}>
            <TooltipInfoIcon className='tooltip-ico mb-1' />
          </OverlayTrigger>
        </Card.Title>

        <Row
          ref={containerRef}
          className='align-items-center justify-content-center'
          id={radarRowId}>
          {data?.length > 0 && radarDivWidth ? (
            renderRadar(data, radarColor, radarDivWidth, maxValue, compareData)
          ) : (
            <span className='not-applicable'>N/A</span>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default RadarCard;
